import React, { Component } from "react";
import likeHover from "../../assets/stories/likes_hover.svg";
import like from "../../assets/stories/like.svg";
import curious from "../../assets/stories/curious.svg";
import celebrate from "../../assets/stories/celebrate.svg";
import sad from "../../assets/stories/sad.svg";
import action from "../../assets/stories/action.svg";
import thank from "../../assets/stories/thank.svg";
import support from "../../assets/stories/support.svg";
import { REACTION_ID_NAME_MATCH, storyReactions } from "../../utils/constants";
import { isMobile } from "../../utils/deviceInfo";
import { Label, Modal } from "reactstrap";
import drillDownClose from "../../assets/drilldown_close.svg";
import Toggle from "react-toggle";

class Reactions extends Component {
  constructor(props) {
    console.log(props.userReacted)
    super(props);
    this.state = {
      showReactions: this.props.hideReactions
        ? this.props.hideReactions
        : false,
      // showReactions: true,
      iconShow: false,
      iconName: "",
      reactionSelected:
        this.props.userReacted &&
          this.props.userReacted[0] &&
          this.props.userReacted[0].reaction
          ? this.props.userReacted[0].reaction
          : null,
      userReactedAnonymous: this.props.userReacted &&
        this.props.userReacted[0] &&
        this.props.userReacted[0].isAnonymous
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.showReactions) {
      this.setState({ showReactions: nextProps.hideReactions });
    }
    if (this.props.userReacted == null) {
      console.log(nextProps, this.props, this.state);
      this.setState({ reactionSelected: null });
    }
  }

  reactionHoverOn = () => {
    this.setState({ showReactions: true });
  };

  reactionHoverOff = () => {
    if (this.state.showReactions) {
      this.setState({ showReactions: false, isAnonymous: false });
    }
  };

  iconNameOn = (e) => {
    this.setState({ iconShow: true, iconName: e });
  };

  iconNameOff = () => {
    if (this.state.iconShow) {
      this.setState({ iconShow: false, iconName: "" });
    }
  };

  addReaction = (val, isAnonymous) => {
    this.setState({
      iconShow: false,
      iconName: "",
      showReactions: false,
      reactionSelected: storyReactions.filter((x) => x._id === val)[0],
      userReactedAnonymous:isAnonymous
    });
    this.props.saveReaction(val, isAnonymous);
  };

  pickImage = (val) => {
    let selected = storyReactions.filter((x) => x._id === val)[0];
    return selected && selected.image;
  };

  pickName = (val) => {
    let selected = storyReactions.filter((x) => x._id === val)[0];
    return selected && selected.name;
  };

  removeReaction = () => {
    this.setState({ reactionSelected: null });
    this.props.removeReaction();
  };

  renderImageText = (e) => {
    if (this.state.iconName === e) {
      const reactionId = REACTION_ID_NAME_MATCH[e];
      return this.state.iconShow ? (
        <div className={`iconName`}>
          <div
            className="icon_name-option"
            onClick={() => {
              this.addReaction(reactionId, false);
            }}
          >
            {this.state.iconName}{" "}
          </div>

          <div
            className="icon_name-option"
            onClick={() => {
              this.addReaction(reactionId, true);
            }}
          >
            {this.state.iconName} Anonymously{" "}
          </div>
        </div>
      ) : null;
    }
  };

  closeReactionModal = () => {
    this.setState({ showReactions: false });
  };

  render() {
    let { reactionSelected } = this.state;
    let reactions;
    // console.log(reactionSelected)
    if (!this.state.showReactions) {
      reactions = null;
    } else if (isMobile) {
      reactions = (
        <Modal isOpen={this.state.showReactions} className="reaction-modal">
          <button
            className="mobileReactionsClose"
            onClick={this.reactionHoverOff}
          >
            <img src={drillDownClose} height="35px" width="35px" />
          </button>
          <div className="reaction-popup">
            <div className="reactionContainer">
              <div className="reaction-title">
                <h5>Reactions</h5>
              </div>
              {/* <span className="model-close" 
      onClick={this.reactionHoverOff}
      > <img src={drillDownClose} height="35px" width="35px" />
      	<i className="flaticon-close"></i>
      </span> */}
              <div className="emoji-box-container">
                <img src={thank} />{" "}
                <div>
                <span
                  onClick={(e) => this.addReaction("reaction_like_01", false)}
                >
                  Like
                </span>{" "}
                <br />
                <span
                  onClick={(e) => this.addReaction("reaction_like_01", true)}
                >
                  Like Anonymously
                </span>{" "}
                </div>
                
              </div>
              <div className="emoji-box-container">
                <img src={thank} />{" "}
                <span
                  onClick={(e) =>
                    this.addReaction("reaction_celebrate_01", false)
                  }
                >
                  Celebrate
                </span>{" "}
                <span
                  onClick={(e) =>
                    this.addReaction("reaction_celebrate_01", true)
                  }
                >
                  Celebrate Anonymously
                </span>{" "}
              </div>
              <div className="emoji-box-container">
                <img src={thank} />{" "}
                <span
                  onClick={(e) =>
                    this.addReaction("reaction_curious_01", false)
                  }
                >
                  Curious
                </span>{" "}
                <span
                  onClick={(e) => this.addReaction("reaction_curious_01", true)}
                >
                  Curious Anonymously
                </span>{" "}
              </div>
              <div className="emoji-box-container">
                <img src={thank} />{" "}
                <span
                  onClick={(e) => this.addReaction("reaction_sad_01", false)}
                >
                  Sad
                </span>{" "}
                <span
                  onClick={(e) => this.addReaction("reaction_sad_01", true)}
                >
                  Sad Anonymously
                </span>{" "}
              </div>
              <div className="emoji-box-container">
                <img src={thank} />{" "}
                <span
                  onClick={(e) =>
                    this.addReaction("reaction_support_01", false)
                  }
                >
                  Support
                </span>{" "}
                <span
                  onClick={(e) => this.addReaction("reaction_support_01", true)}
                >
                  Support Anonymously
                </span>{" "}
              </div>
              <div className="emoji-box-container">
                <img src={thank} />{" "}
                <span
                  onClick={(e) => this.addReaction("reaction_action_01", false)}
                >
                  Action
                </span>{" "}
                <span
                  onClick={(e) => this.addReaction("reaction_action_01", true)}
                >
                  Action Anonymously
                </span>{" "}
              </div>
              <div className="emoji-box-container">
                <img src={thank} />{" "}
                <span
                  onClick={(e) => this.addReaction("reaction_thanks_01", false)}
                >
                  Thanks
                </span>{" "}
                <span
                  onClick={(e) => this.addReaction("reaction_thanks_01", true)}
                >
                  Thanks Anonymously
                </span>{" "}
              </div>
            </div>
          </div>
        </Modal>
      );
    } else if (!isMobile) {
      reactions = (
        <div>
          <div
            className="reactionContainer"
            onClick={this.reactionHoverOn}
            onMouseLeave={this.reactionHoverOff}
          >
             <span 
              // style={{ fontSize: "12px", whiteSpace: "nowrap" }} 
              className="reactionContainer-text-alert">
                To react anonymously, hover over the icon
              </span>
            {/* <div className="mb-1">
              <span 
              // style={{ fontSize: "12px", whiteSpace: "nowrap" }} 
              className="reactionContainer-text-alert">
                To react anonymously, hover over the icon
              </span>
            </div> */}
            <div className="reactionContainerWrapper">
              <div
                onMouseOver={(e) => this.iconNameOn("Like")}
                onMouseLeave={this.iconNameOff}
                 className="reaction_wrapper_item"
              >
                <img
                  src={like}
                // onClick={(e)=>this.addReaction("reaction_like_01")}
                />
                {this.renderImageText("Like")}
              </div>

              <div
                onMouseOver={(e) => this.iconNameOn("Celebrate")}
                onMouseLeave={this.iconNameOff}
                 className="reaction_wrapper_item"
              >
                <img
                  src={celebrate}
                // onClick={(e)=>this.addReaction("reaction_celebrate_01")}
                />
                {this.renderImageText("Celebrate")}
              </div>

              <div
                onMouseOver={(e) => this.iconNameOn("Curious")}
                onMouseLeave={this.iconNameOff}
                 className="reaction_wrapper_item"
              >
                <img
                  src={curious}
                // onClick={(e)=>this.addReaction("reaction_curious_01")}
                />
                {this.renderImageText("Curious")}
              </div>

              <div
                onMouseOver={(e) => this.iconNameOn("Sad")}
                onMouseLeave={this.iconNameOff}
                 className="reaction_wrapper_item"
              >
                <img
                  src={sad}
                // onClick={(e)=>this.addReaction("reaction_sad_01")}
                />
                {this.renderImageText("Sad")}
              </div>

              <div
                onMouseOver={(e) => this.iconNameOn("Support")}
                onMouseLeave={this.iconNameOff}
                 className="reaction_wrapper_item"
              >
                <img
                  src={support}
                // onClick={(e)=>this.addReaction("reaction_support_01")}
                />
                {this.renderImageText("Support")}
              </div>

              <div
                onMouseOver={(e) => this.iconNameOn("Thanks")}
                onMouseLeave={this.iconNameOff}
                 className="reaction_wrapper_item"
              >
                <img
                  src={thank}
                // onClick={(e)=>this.addReaction("reaction_thanks_01")}
                />
                {this.renderImageText("Thanks")}
              </div>

              <div
                onMouseOver={(e) => this.iconNameOn("Action")}
                onMouseLeave={this.iconNameOff}
                 className="reaction_wrapper_item"
              >
                <img
                  src={action}
                // onClick={(e)=>this.addReaction("reaction_action_01")}
                />
                {this.renderImageText("Action")}
              </div>
            </div>
          </div>{" "}
        </div>
      );
    }
    return (
      <div className="reactionsComponent">
        {reactions}

        {reactionSelected ? (
          <div className="reactionSelected" onClick={this.removeReaction}>
            <img
              src={
                reactionSelected.image
                  ? reactionSelected.image
                  : this.pickImage(reactionSelected)
              }
            />
            {reactionSelected.name
              ? reactionSelected.name
              : this.pickName(reactionSelected)}

            {
              this.state.userReactedAnonymous ? <span className="story_reaction_anonymous_parenthesis">(anonymous) </span>: ""
            }
          </div>
        ) : (
          <div
            onMouseOver={(e) => !isMobile && this.reactionHoverOn()}
            onClick={(e) => isMobile && this.reactionHoverOn()}
          >
            <img src={likeHover} /> Like
          </div>
        )}
      </div>
    );
  }
}

export default Reactions;
